<script setup>
defineProps({
	prize: {
		type: Object,
		required: true,
	},
});

const emit = defineEmits(["exchange", "info"]);
</script>
<template>
	<div class="slide">
		<div class="slide__container">
			<div class="slide__image">
				<img width="178" height="112" :src="prize.images[0]" :alt="prize.title" />                
			</div>
			<h4 class="slide__name">{{ prize.title }}</h4>
			<button class="slide__info" type="button" @click="emit('info', prize)">
				<svg width="32" height="32"><use  xlink:href="#info"></use></svg>
			</button>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.slide {
	display: flex;
    width: 100%;
    height: 100%;
	&__container {
		display: flex;
		align-items: center;
		position: relative;
		width: 100%;
		padding: 2.8rem 5.6rem 2.7rem;
		gap: 7.3rem;
		border-radius: 2.8rem;
		border: 1px solid var(--border-accent-2-4);
		background: rgba(255, 255, 255, 0.01);
		backdrop-filter: blur(0.77rem);
		box-shadow: inset 0 1.3rem 3.48rem 0 rgba(255, 255, 255, 0.14);
		@media (max-width: vars.$xx) {
			gap: 3rem;
			padding: 5rem 6rem 3.2rem;
		}
		@media (max-width: vars.$x480) {
			flex-direction: column;
			gap: 1rem;
        padding: 1rem 6.5rem 3.2rem;
		}
	}   

	&__image {
		width: 18rem;
		overflow: hidden;
		@media (max-width: vars.$x480) {
			width: 22rem;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	&__info {
		position: absolute;
		top: 1.5rem;
		right: 1.5rem;
		width: 3.2rem;
		height: 3.2rem;
		
		transition: opacity var(--transition);

		@media (hover: hover) {
			&:hover {
				opacity: 0.7;
			}
		}

		@media (max-width: vars.$x480) {
			top: 1rem;
			right: 1rem;
			width: 2rem;
			height: 2rem;
		}

		svg {
			width: 100%;
			height: 100%;
			stroke: transparent;
			@media (max-width: vars.$x480) {
			}
		}
	}

	&__name {
		font-family: var(--font-family);
		font-weight: 500;
		font-size: 3.2rem;
		line-height: 160%;
		color: var(--text-accent-2-100);
		max-width: 314px;
		@media (max-width: vars.$x480) {
			font-size: 2rem;
			line-height: 120%;
			text-align: center;
		}
	}

	
}
</style>
